import * as React from 'react';
import { UserModel, UserDataModel } from 'franke-trough-dependencies';
import './UserListItem.scss';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { filterUsersBySword, userIsInternal, userExistsInArray, userHasRole } from '../utils';
import { filter as _filter } from 'lodash';
import { DebounceInput } from 'react-debounce-input';
import classNames from 'classnames';
import cog from '../../../../assets/images/icons/cog.svg';
import bin from '../../../../assets/images/icons/bin.svg';
import UserListItemAdd from './UserListItemAdd';
import UserListItemRemove from './UserListItemRemove';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import UserListDeleteModal from './UserListDeleteModal';
import exclamation from '../../../../assets/images/icons/exclamation.svg';

 
export interface UserListItemProps {
  user: UserModel;
  usersAdminList: GlobalPrivateState['users'];
  queryState: GlobalPrivateState['queryState'];
  drilledRoleChange?: (user: UserModel, role: string) => void;
  drilledDelete: (user: UserModel) => void;
  language: GlobalPrivateState['localize']['language'];
  dispatch: any;
}

export interface UserListItemState {
  user: UserModel;
  currentRole: string;
  isOpen: boolean;
  isDeleting: boolean;
  searchTerm: string;
}

export class UserListItemRemovePartial extends React.Component<UserListItemProps, UserListItemState> {
  constructor(props: UserListItemProps) {
    super(props);
    const user = this.props.user;

    this.state = {
      user,
      currentRole: this.currentRole(user),
      isOpen: false,
      isDeleting: false,
      searchTerm: ''
    };
  }

  componentDidUpdate(prevState: UserListItemProps) {
    if (JSON.stringify(this.props.user) !== JSON.stringify(prevState.user)) {
      this.setState({
        user: this.props.user
      });
    }
  }

  public render() {
    const user = this.state.user;
    const userData = (user.userData as UserDataModel);
    const firstName = userData && userData.firstName;
    const lastName = userData && userData.lastName;
    const country = userData && userData.country.split('-')[1];
    const registration = userData && new Date(userData.created_at).toLocaleDateString(this.props.language.selected, {timeZone: 'UTC'});
    const labour = userData && userData.labour || '';
    
    const userListForAdding = this.userListForAdding;
    const userListForRemoving = this.userListForRemoving;

    // console.log('userListForRemoving', userListForRemoving);

    return (
      <li key={user.id} className={classNames(
        'user-list-item user-list-item--manage', {
          'user-list-item--open': this.state.isOpen,
          'user-list-item--clickable': (this.state.currentRole === 'internal' || this.state.currentRole === 'salesrep')
        })}>
        <div className="user-list-item__header">
          <span className="user-list__first" title={firstName}>{!userData && <img className="img-fluid" src={exclamation} alt="User not registered" title="User not registered"/>}{firstName}</span>
          <span className="user-list__last" title={lastName}>{lastName}</span>
          <span className="user-list__email" title={user.email}>{user.email}</span>
          <span className="user-list__country">{country}</span>
          <span className="user-list__registration">{registration}</span>
          <span className="user-list__labour">
            {userData && (
              <>
                <span className="user-list__label">Labour:</span>
                <select 
                  className="form-control"
                  name="labour"
                  value={labour}
                  onChange={this.handleLabourChange}
                > 
                  <option value={''}>No Labour</option>
                  <option value={'FAR'}>FAR</option>
                  <option value={'FAH'}>FAH</option>
                </select>
              </>
            )}
          </span>
          <span className="user-list__role">
            <span className="user-list__label">Role:</span>
            <select 
              className="form-control"
              name="plateDepth"
              value={this.state.currentRole}
              onChange={this.handleRoleChange}
            > 
              <option value={'internal'}>Internal</option>
              <option value={'external'}>External</option>
              <option value={'salesrep'}>Sales Rep</option>
            </select>
          </span>
          <span className="user-list__action">
            {(this.state.currentRole === 'internal' || this.state.currentRole === 'salesrep') && (
              <img 
                className="img-fluid" 
                src={cog}
                alt="edit"
                onClick={this.handleToggleOpen}
              />
            )}
          </span>
          <span className="user-list__action">
            <img 
              className="img-fluid" 
              src={bin}
              alt="delete"
              onClick={this.handleDelete}
            />
          </span>
        </div>
        {this.state.isOpen && (
          <div className="user-list-item__body">
            <div className="user-list-item__search">
              <h2>Add User</h2>
              <form 
                className="form form-search"
                onSubmit={(e) => {e.preventDefault();}}
              >
                <DebounceInput
                  className="form-control w-100"
                  id="form_search_main"
                  type="text"
                  value={this.state.searchTerm}
                  placeholder="Search for a user to be managed..."
                  onChange={this.handleSearchChange}
                  disabled={false}
                  name="search"
                  debounceTimeout={50}
                />
              </form>
            </div>
            {this.props.usersAdminList.result ? (
              <>
                <ol className="user-list">
                  {userListForAdding && (
                    <>
                      {userListForAdding.length > 0 ? (
                        userListForAdding.map((user: UserModel) => {
                          const drilledAddUserMethod = userExistsInArray(userListForRemoving, user) ? undefined : this.onDrilledAddUser;
                          return <UserListItemAdd key={user.id} user={user} drilledAddUser={drilledAddUserMethod} />
                        })
                      ) : (
                        <h3>No users found...</h3>
                      )}
                    </>
                  )}
                </ol>
                {userListForRemoving && userListForRemoving.length > 0 && (
                  <>
                    <h2>Remove User</h2>
                    <ol className="user-list">
                      {userListForRemoving.map((user: UserModel) => {
                        return <UserListItemRemove key={user.id} user={user} manager={this.state.user} drilledUpdateManagee={this.onDrilledUpdateManagee} drilledRemoveManagee={this.onDrilledRemoveManagee} />
                      })}
                    </ol>
                  </>
                )}
              </>
            ) : (
              <h3>Loading...</h3>
            )}
          </div>
        )}
        {this.state.isDeleting && (
          <UserListDeleteModal
            user={user} 
            drilledClose={this.onDrilledCloseDelete}
            drilledConfirm={this.onDrilledConfirmDelete}
          />
        )}
      </li>
    );
  }

  get userListForAdding() {
    const user = this.state.user;
    const sword = this.state.searchTerm;

    // if (!sword || sword.length <= 2) { return; } 

    const usersAdminList = this.props.usersAdminList.result;

    if (!usersAdminList) { return }

    const users = usersAdminList && usersAdminList.users;
    const matchingUsers = filterUsersBySword(users, sword) || [];
    // const externalMatchingUsers = _filter(matchingUsers, (u: UserModel) => !userIsInternal(u));
    const externalMatchingUsersWithoutUser = _filter(matchingUsers, (u: UserModel) => u.id !== user.id);

    return externalMatchingUsersWithoutUser.slice(0, 4);
  }

  get userListForRemoving() {
    return this.state.user.managees || [];
  }

  handleSearchChange = (event: any) => {
    // Search changed...
    this.setState({
      ...this.state,
      searchTerm: event.target.value
    })
  }

  handleToggleOpen = (event: any) => {
    if (!this.state.currentRole) { return; }

    this.setState({
      ...this.state,
      isOpen: !this.state.isOpen
    });
  }

  handleRoleChange = (event: any) => {
    if (!this.props.drilledRoleChange) { return; }

    const user = this.state.user;
    const newRole = event.target.value;

    this.props.drilledRoleChange(user, newRole);

    // I want to update state after the response has succeeded... how?
    // I can set a temp state, or I can change the store ugh...
    this.setState({
      currentRole: newRole,
      isOpen: false
    });
  }

  handleLabourChange = (event: any) => {
    const user = this.props.user;
    if (!user.userData) { return; }

    const target = event.target as HTMLSelectElement;
    const value: any = target.value;

    // UserData object
    user.userData.labour = value;

    // Update on API
    this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
      'userDataAdminned', {
        url: `/UserData/${user.userData.id}`,
        options: {
          method: 'PATCH',
          data: user.userData,
        },
      },
      true
    ));

    // Update local state too
    this.setState({
      ...this.state,
      user
    });
  }

  handleDelete = (event: any) => {
    this.setState({
      ...this.state,
      isDeleting: true
    });
  }

  onDrilledCloseDelete = () => {
    this.setState({
      ...this.state,
      isDeleting: false
    });
  }

  onDrilledUpdateManagee = (managee: UserModel) => {
    // this.state.user.managees
    const user = this.state.user;

    if (!user.managees) { 
      user.managees = [];
    }

    const changedManageeIndex = user.managees.findIndex(m => m.id === managee.id);
    if (typeof changedManageeIndex === 'undefined') { return; }

    user.managees[changedManageeIndex] = managee;

    this.setState({
      ...this.state,
      user
    });
  }

  onDrilledConfirmDelete = (user: UserModel) => {
    this.props.drilledDelete(user);
  }

  onDrilledAddUser = async (managee: UserModel) => {
    const user = this.props.user;

    const mapping = {
      managerId: user.id,
      manageeId: managee.id
    }
    
    this.props.dispatch(requestAPIActions.load(
      'users', {
        url: `/ManageMappings/upsertWithWhere?where=${JSON.stringify(mapping)}`,
        options: {
          method: 'POST',
          data: mapping
        }
      },
      false
    ));

    // If other user is internal, make this user assigned to them too
    const hasBiwayConnection = managee.manageeMapping && managee.manageeMapping.find(mapping => mapping.managerId === managee.id && mapping.manageeId === user.id);
    const manageeIsInternal = managee.roles && managee.roles.find(role => role.name === 'internal' || role.name === 'salesrep');
    if (!hasBiwayConnection && manageeIsInternal) {
      
      const reverseMapping = {
        managerId: managee.id,
        manageeId: user.id
      }
      
      this.props.dispatch(requestAPIActions.load(
        'users', {
          url: `/ManageMappings/upsertWithWhere?where=${JSON.stringify(reverseMapping)}`,
          options: {
            method: 'POST',
            data: reverseMapping
          }
        },
        false
      ));
    }

    // TODO - Update state elsewhere depending on manageMapping response...
    // if (user.managees) {
    //   user.managees.push(managee);

    //   this.setState({
    //     ...this.state,
    //     user
    //   })
    // }
  }

  onDrilledRemoveManagee = async (managee: UserModel) => {
    const user = this.props.user;
    const mapping = managee.manageeMapping && managee.manageeMapping.find(mapping => mapping.managerId === user.id && mapping.manageeId === managee.id);

    if (!mapping) { return; }

    this.props.dispatch(requestAPIActions.load(
      'users', {
        url: `/ManageMappings/${mapping.id}`,
        options: {
          method: 'DELETE'
        }
      },
      false
    ));

    // Remove the mapping on the other user too if it exists... we dont even check if they are internal because no point really
    const reverseMapping = user.manageeMapping && user.manageeMapping.find(mapping => mapping.managerId === managee.id && mapping.manageeId === user.id);
    if (reverseMapping) {
      this.props.dispatch(requestAPIActions.load(
        'users', {
          url: `/ManageMappings/${reverseMapping.id}`,
          options: {
            method: 'DELETE'
          }
        },
        false
      ));
    }
  }

  currentRole = (user: any) => {
    if (!user) {
      user = this.state.user;
    }

    return userHasRole(user, 'internal') ? 'internal' : userHasRole(user, 'salesrep') ? 'salesrep' : 'external';
  }
}

export const UserListItemManage = connect((state: GlobalPrivateState) => ({
  language: state.localize.language,
  usersAdminList: state.users,
  queryState: state.queryState
}))(UserListItemRemovePartial);

export default UserListItemManage;
